import { useCallback, useContext, useEffect, useRef } from 'react'

import {
  ProposalV2TemplateSettingsContext,
  proposalV2TemplateSettingsSelectors,
  SET_SUBMITTING_PROPOSAL_V2_TEMPLATE_SETTINGS,
} from 'projectSections/form/context/ProposalV2TemplateSettingsContext'
import { useLongProcessErrorHandler } from 'ra-core'

const useCheckForActiveEditor = () => {
  const { state, dispatch } = useContext(ProposalV2TemplateSettingsContext)
  const unsavedTemplateSettings = proposalV2TemplateSettingsSelectors.unsavedTemplateSettings(state)

  const isEditorActiveRef = useRef(state.isEditorActive)
  const isWaitingForChangeRef = useRef<boolean>(false)
  const unsavedTemplateSettingsRef = useRef(unsavedTemplateSettings)

  const longErrors = useLongProcessErrorHandler()

  useEffect(() => {
    isEditorActiveRef.current = state.isEditorActive

    if (state.isEditorActive) isWaitingForChangeRef.current = true
  }, [state.isEditorActive])

  useEffect(() => {
    unsavedTemplateSettingsRef.current = unsavedTemplateSettings

    if (isWaitingForChangeRef.current) {
      isWaitingForChangeRef.current = false
    }
  }, [unsavedTemplateSettings])

  const handleCheckForActiveEditor = useCallback(async () => {
    if (isEditorActiveRef.current) {
      dispatch({
        type: SET_SUBMITTING_PROPOSAL_V2_TEMPLATE_SETTINGS,
        payload: { submitting: true },
      })

      let editorActiveIntervalId: NodeJS.Timeout | null = null
      const promise = new Promise<void>((resolve) => {
        editorActiveIntervalId = setInterval(() => {
          if (!isEditorActiveRef.current && !isWaitingForChangeRef.current) {
            if (editorActiveIntervalId) clearInterval(editorActiveIntervalId)
            resolve()
          }
        }, 500)
      })

      return longErrors.promise(
        15_000,
        new Error('Update unsavedTemplateSettings with active changes incomplete even after 15s'),
        promise
      ) as Promise<void>
    }

    return new Promise<void>((resolve) => {
      resolve()
    })
  }, [dispatch])

  return {
    handleCheckForActiveEditor,
    unsavedTemplateSettingsRef,
  }
}

export default useCheckForActiveEditor
